import { FC } from 'react';

import { LoginForm } from '@shared/components/LoginForm';
import { useAuth } from '@shared/state/hooks/useAuth';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import GiftBrandAuthRouter from './GiftBrandAuthRouter';

const GiftBrandLoginPage: FC = () => {
  const redirectUrl =
    sessionStorage.getItem('redirectUrlAfterGiftBrandLogin') ?? '/gift-brand';
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="w-full max-w-md rounded-lg bg-white p-8 shadow">
        <h1 className="mb-6 text-center text-xl font-bold">답례품 배송관리자 로그인</h1>
        <LoginForm redirectUrl={redirectUrl} />
      </div>
    </div>
  );
};

export const GiftBrandRouter: FC = function GiftBrandRouter() {
  const { isGiftBrandSeller, isAdmin } = useAuth();
  const { pathname, search } = useLocation();
  const isAuthenticated = isGiftBrandSeller() || isAdmin();

  if (
    pathname !== '/gift-brand/login' &&
    pathname !== '/gift-brand' &&
    !isAuthenticated
  ) {
    sessionStorage.setItem('redirectUrlAfterGiftBrandLogin', pathname + search);
  }

  return (
    <div className="bg-white">
      <Routes>
        <Route
          path="login"
          element={
            !isAuthenticated ? (
              <GiftBrandLoginPage />
            ) : (
              <Navigate to="/gift-brand" />
            )
          }
        />
        <Route path="*" element={<GiftBrandAuthRouter />} />
      </Routes>
    </div>
  );
};
